<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead :title="'Operator Departure Cities'"></cardHead>
      <dataTable
        :name="'TourScopeOperatorDepartureCities'"
        ref="agGrid"
        :columnDefs="columnDefs"
        :data="data"
        @update="matchShow = $event"
        @cellClicked="matchShow = $event.data"
        :rowClassRules="{
          // row style function
          success: (params) => {
            // var numSickDays = params.data;
            return params?.data?.DepartureCityName != null;
          },
        }"
      ></dataTable>
      <match
        v-if="matchShow != null"
        :setModel="matchShow"
        :operators="data"
        @match="getRow"
        @close="matchShow = null"
      ></match>
    </div>
  </div>
</template>

<script>
import match from "./match";
export default {
  name: "DepartureCities",
  components: { match },
  data() {
    return {
      columnDefs: [
        {
          headerName: "Id",
          width: 80,
          filter: "agNumberColumnFilter",
          field: "Id",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "OperatorId",
          width: 140,
          filter: "agNumberColumnFilter",
          field: "OperatorId",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Name",
          filter: "agTextColumnFilter",
          field: "Name",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Operator",
          filter: "agTextColumnFilter",
          field: "OperatorName",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "City",
          filter: "agTextColumnFilter",
          field: "DepartureCityName",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Code1",
          width: 85,
          filter: "agTextColumnFilter",
          field: "Code1",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Code2",
          width: 85,
          filter: "agTextColumnFilter",
          field: "Code2",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Code3",
          width: 85,
          filter: "agTextColumnFilter",
          field: "Code3",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Code4",
          width: 85,
          filter: "agTextColumnFilter",
          field: "Code4",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "",
          type: "action",
          width: 40,
          buttons: [
            {
              classes: "btn btn-xs waves-effect waves-light btn-warning",
              text: '<i class="fas fa-exchange-alt"></i>',
              emit: "update",
            },
          ],
          filter: false,
          sortable: false,
          resizable: false,
          floatingFilter: false,
        },
      ],
      data: null,
      matchShow: null,
    };
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.$appAxiosAdmin
        .get("tourscope/OperatorDepartureCities")
        .then((response) => {
          this.data = response.data.sort((x) =>
            x.DepartureCityName == null ? -1 : 2
          );
        });
    },
    getRow() {
      this.get();
    },
  },
  computed: {},
};
</script>
